import React from "react";
import { CONF } from "../lib/theme";

export default function ConfidenceSelector({ value, onChange, idPrefix = "conf" }) {
  return (
    <div className="mt-4">
      <div className="mb-2 font-mono text-[11px] uppercase tracking-wider text-muted">How sure are you?</div>
      <div className="grid grid-cols-4 gap-2">
        {CONF.map((c) => {
          const active = value === c.v;
          return (
            <button
              key={c.v}
              type="button"
              data-testid={`${idPrefix}-${c.v}`}
              onClick={() => onChange(c.v)}
              className="rounded-md border px-2 py-2 text-left transition-colors"
              style={{
                borderColor: active ? c.color : "rgba(255,255,255,0.08)",
                background: active ? `${c.color}1f` : "transparent",
              }}
            >
              <div className="font-mono text-sm" style={{ color: active ? c.color : "#8B93A5" }}>{c.v}</div>
              <div className="text-xs" style={{ color: active ? "#E6E8EE" : "#8B93A5" }}>{c.label}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
